// extracted by mini-css-extract-plugin
export default {"container":"_c75b8","box":"_ae943c6a","header":"_db512bc0","message":"_aefa4534"};